import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _isEmpty from 'lodash/isEmpty';
export function getSelectOptions(options) {
  return options.map(function (option) {
    return {
      key: option.value,
      value: option.value,
      text: option.label
    };
  });
}
export function validateRequiredField(field, value) {
  var required = field.required,
    name = field.name,
    label = field.label;
  if (required && _isEmpty(value)) {
    return _defineProperty({}, name, "".concat(label, " is required"));
  }
  return {};
}
export function createFormFieldRowKey(uuid, fieldRow) {
  if (_isEmpty(fieldRow)) {
    return "".concat(uuid, "-row}");
  }
  return "".concat(uuid, "-row-").concat(fieldRow.map(function (_ref2) {
    var name = _ref2.name;
    return name;
  }).join('|'));
}